import React, { lazy } from "react";
import { Loader } from "../root/loader";
const NewCustomer = lazy(() => import("./components/newcustomer"));

export const newcustomer = () => [
    {
        target: "$ONE_LAYOUT_ROUTE",
        handler: {
            exact: true,
            path: "/newcustomer",
            element: (
                <Loader>
                    <NewCustomer />
                </Loader>
            )
        }
    }
];
